<template>

    <div class="d-flex flex-column min-vh-100">
        <main class="flex-fill container mt-3 mb-3 flex-column justify-content-center">
            <StepEmail v-if="step === 1" :apiErrorMessage="apiErrorMessage" @next="handleEmailNext"/>
            <StepForm v-if="step === 2" :apiErrorMessage="apiErrorMessage" :email="email" :userData="userData" :codeClient="codeClient" :userExists="userExists" @next="handleFormNext"/>
            <StepConfirm v-if="step === 3" :codeClient="codeClient" :userExists="userExists" :userFull="userFull"/>
        </main>
        
        <MentionsLegales />
    </div>

</template>

<script>
import StepEmail from '../components/FormClient/StepEmail.vue';
import StepForm from '../components/FormClient/StepForm.vue';
import StepConfirm from '../components/FormClient/StepConfirm.vue';
import MentionsLegales from '../components/FormClient/MentionsLegales.vue';
import { getCodeClientWithContexte, getInfoClientWithCodeClient, postFormulaire, postOptinFormulaire } from '../services/UserService';
import { useRoute } from 'vue-router';

export default {
    name: 'FormClientView',
    components : { StepEmail, StepForm, StepConfirm, MentionsLegales },
    data() {
        return {
            step: 1,
            email: '',
            form: {},
            userData: null,
            codeClient: null,
            userExists: null,
            userRegistered: null,
            canalRecrutement: '',
            userFull: null,
            optinIdNewsletter: '3',
            apiErrorMessage: ''
        };
    },
    setup() {
        const route = useRoute();
        return { route };
    },
    methods: {
        createOptinPayload() {
            const optinForm = {
                codeClient: this.codeClient,
                email: this.email,
                optins: [
                    {
                        id: this.optinIdNewsletter, //newsletter Armor
                        valeur: 1,
                    }
                ],
                codeLangue: 'FR'
            }

            return optinForm;
        },
        isUserComplete(userData) {
            return userData 
            && userData.titre 
            && userData.prenom
            && userData.nom 
            && userData.telephone
            && userData.adresse && userData.adresse.adresse1 && userData.adresse.codePostal && userData.adresse.ville 
            && userData.jour && userData.mois && userData.annee 
            && userData.optins.valeur === 'oui';
        },
        async handleEmailNext({ email }) {
            this.email = email;
            this.apiErrorMessage = '';

            try {
                // Vérifie si le client existe
                const res = await getCodeClientWithContexte(email, this.route.params.c);

                this.codeClient = res.codeClient;
                this.userExists = Number(res.clientExiste);
                this.userRegistered = res.inscrit;

                if (this.userExists === 1) {
                    //Récupérer les informations du client
                    const user = await getInfoClientWithCodeClient(this.codeClient);
                    this.userData = user;
                } else {
                    this.userData = {};
                }

                // Si le profil est complet, on passe au code barre
                // Sinon, on affiche le formulaire
                if (this.isUserComplete(this.userData)) {
                    // Création l'optin pour la newsletter
                    const optins = this.createOptinPayload();
                    await postOptinFormulaire(optins);
                    
                    this.step = 3;
                    this.userFull = 1;

                } else {
                    this.step = 2;
                }
            } catch (error) {
                console.error('Erreur API :', error);
                this.apiErrorMessage = "Une erreur est survenue. Veuillez réessayer.";
            }
            
        },
        async handleFormNext({ form }) {
            this.apiErrorMessage = '';
            try {
                // Création ou update du client
                const res = await postFormulaire(form);

                if (res == 1) {
                    // Création l'optin pour la newsletter
                    const optins = this.createOptinPayload();
                    await postOptinFormulaire(optins);
                }
                this.step = 3;
            } catch (err) {
                console.error("Erreur lors de l'envoi du formulaire :", err);
                this.apiErrorMessage = "Une erreur est survenue. Veuillez réessayer.";
            }
        }
    }
}

</script>

<style>

.title {
    color: var(--color-form-braderie);
    text-transform: uppercase;
    font-size: 25px;
    font-family: "InriaSerif-Bold", sans-serif;
}

.button-braderie {
  color: #ffffff;
  background-color: var(--color-form-braderie);
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 8px 45px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 20px;
}

</style>